import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';

const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

const userModule = {
  state: {
    user: {},
    selectedProjectSite: {},
  },

  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    unsetUser(state) {
      state.user = null;
    },

    setLoginError(state, payload) {
      state.loginError = payload;
    },
    unsetLoginError(state) {
      state.loginError = null;
    },

  },

  getters: {
    getLoggedInUser: (state) => state.user,
    getLoginError: (state) => state.loginError,
  },
};

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
      paths: ['user'],
    }),
  ],

  modules: {
    user: userModule,
    // households: householdsModule,
  },
  // state: {
  //   user: null,
  //   households: null,
  // },
  // mutations: {
  //   setUser(state, payload) {
  //     state.user = payload;
  //   },
  //   unsetUser(state) {
  //     state.user = null;
  //   },

  //   setHouseholds(state, payload) {
  //     state.households = payload;
  //   },
  //   unsetHouseholds(state) {
  //     state.households = null;
  //   },
  // },
  // actions: {},
  // getters: {
  //   getLoggedInUser: (state) => state.user,
  //   getHouseholds: (state) => state.households,
  // },
});
